import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'
import { WalletRestrictions, isWalletRestrictionsAllowed } from '@utils/wallet.utils'

import { WalletDto, WalletTypeEnum } from '@model/WalletDto'

export type WithdrawalWalletDisabledReason = 'balance' | 'restriction' | 'negative-equity'

export const getWithdrawalWalletDisabledReason = (
  wallet: WalletDto,
  hasNegativeEquity: boolean
): WithdrawalWalletDisabledReason | null => {
  if (!isWalletRestrictionsAllowed(wallet, WalletRestrictions.WITHDRAW)) return 'restriction'
  if (wallet.balance < 0) return 'balance'
  if (hasNegativeEquity) return 'negative-equity'
  return null
}

export const useWithdrawalWallets = (walletType: WalletTypeEnum) => {
  const apiClient = useApiClient(ClientApiClient)

  const { data: wallets, isLoading: isWalletsLoading } = useQuery({
    queryKey: queryKeys.withdrawal.wallets(walletType),
    queryFn: () => apiClient.getWallets({ walletTypeId: walletType }),
    refetchOnMount: 'always',
  })

  return { wallets: wallets ?? [], isWalletsLoading }
}
